import { jsx as _jsx } from "react/jsx-runtime";
import { brandConfiguration } from "@/brands/config";
import { useContactContext, useContactSections } from "@/contexts/contact";
import { useContactingTestId } from "@/hooks";
import { useI18n } from "@/shared/hooks";
import { Modal } from "@gemini/ui";
import { ContactFormWithLead } from "../../ContactForm/ContactFormWithLead";
export const ContactModal = () => {
    const { t } = useI18n();
    const rootTestID = useContactingTestId("ContactModal");
    const { toggleModal, closeModal, isOpen, avZone } = useContactContext();
    const { contactModalTitlePrivate, contactModalTitleAgency } = brandConfiguration.lokaliseSpecificKeys;
    // @ts-ignore
    const isPrivateOwner = useContactSections().contactCard.isPrivateOwner;
    const onOpenChange = () => {
        toggleModal({
            av_zone: avZone,
            legacyTrackingInfos: "detail-right", //tracking GA3 for harvest
        });
    };
    return (_jsx(Modal, { testId: rootTestID, title: t(isPrivateOwner ? contactModalTitlePrivate : contactModalTitleAgency), titleAs: "h2", trigger: () => null, isOpen: isOpen, onOpenChange: onOpenChange, isDismissable: true, children: _jsx(ContactFormWithLead, { isModal: true, av_zone: avZone, close: closeModal }) }));
};
